// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd0ce53b","239":"76ff2d62","455":"bdd52e73"}[chunkId] + ".chunk.js";
};